// extracted by mini-css-extract-plugin
export default {"footerTitle":"ServicesPageFooter_footerTitle__O3UbT","serviceFooter":"ServicesPageFooter_serviceFooter__scPP3"};